import ContactService from "../../../shared/services/ContactService";
import { db } from "../../../shared/plugins/firebase-app";

const contactService = new ContactService(db);
export default contactService;
